module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAALUlEQVQokWMom778PwMaKJu+/D8hzIBNI1FgmGskO3AGSCM5YKhpJCpBY9EIAGGFYS1N/jmXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/border-img-dashed-long.png
// module id = 810
// module chunks = 0